import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import React from "react";
import sendRequest from "../../dataProvider/sendRequest";
import CustomPaper from "../../unit/CustomPaper";
import CustomTableContainer from "../../unit/CustomTableContainer";
import CustomTable from "../../unit/CustomTable";
import formatDate from "../../unit/formatDate";
const TableCellRight = styled(TableCell)({
  textAlign: "right",
  fontFamily: "Roboto",
});

const CustomSummaryTextHistory = ({ ...props }) => {
  const userId = props.userId;
  const [dateList, setDateList] = React.useState<any>(null);

  React.useEffect(() => {
    const reqUrl = "customers/message/history";
    sendRequest(reqUrl, {
      id: userId,
      data: {
        action: "texthistory",
      },
    }).then((response) => {
      setDateList(response?.data);
    });
  }, [userId]);

  if (!dateList) {
    return <div>Loading...</div>;
  }

  return (
    <div
      key={"user_email_history_" + userId}
      style={{
        width: `100%`,
        maxWidth: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      <CustomTableContainer component={CustomPaper}>
        <CustomTable stickyHeader id="table-customer-summary-email-list">
          <TableHead>
            <TableRow>
              <TableCell className="hm-table-header">Message #</TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                App ID
              </TableCell>
              {/* <TableCell className="hm-table-header">Send To</TableCell> */}
              <TableCell className="hm-table-header">Template</TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Time Sent
              </TableCell>
              {/* <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Time Opened
              </TableCell> */}
              <TableCell className="hm-table-header">Sent Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dateList == undefined ||
            dateList.length == 0 ||
            dateList == null ? (
              <TableRow>
                <TableCell colSpan={8}>No record. </TableCell>
              </TableRow>
            ) : (
              dateList.map((item: any) => (
                <TableRow key={item.iId + " " + item.dtInsert}>
                  <TableCell>{item?.logId}</TableCell>
                  <TableCell>{item?.appId}</TableCell>
                  {/* <TableCell>{item?.email}</TableCell> */}
                  <TableCell>{item?.template}</TableCell>
                  <TableCell>{formatDate(item?.sentAt)}</TableCell>
                  {/* <TableCell>{formatDate(item?.readAt)}</TableCell> */}
                  <TableCell>{item?.sStatus}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </div>
  );
};

export default CustomSummaryTextHistory;
